import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import StoreBadges from "@/components/StoreBadges";

const IMG = "https://images.unsplash.com/photo-1508672019048-805479767531?q=80&w=1600&auto=format&fit=crop";

export default function CtaBanner({ title = "Stop leaving hours early.", sub = "Download Tripsee and let live data decide when you walk out the door." }) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMG} alt="Cockpit instruments glowing at night" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0D] via-[#0B0B0D]/70 to-[#0B0B0D]" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 sm:py-36 text-center">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-primary uppercase mb-6">Cleared for departure</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white max-w-3xl mx-auto">
            {title}
          </h2>
          <p className="mt-6 text-lg text-slate-400 max-w-xl mx-auto leading-relaxed">{sub}</p>
          <div className="mt-10 flex flex-col items-center justify-center gap-6">
            <StoreBadges testIdPrefix="cta-banner" />
            <Link
              to="/features"
              data-testid="cta-banner-features-link"
              className="inline-flex items-center gap-2 text-base font-semibold text-slate-300 hover:text-primary transition-colors duration-200"
            >
              Explore features <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
